import Vue from 'vue'
// IM - 即时通讯
// import TIM from 'tim-js-sdk' //利用cdn 控制
import Avatar from '@/components/IM/avatar'
// import imMixins from '@/mixins/imMixins.js'
// import TIM from 'tim-js-sdk'
import tim from '@/utils/IM/tim'
import '@/assets/icon/tim.css'
Vue.component('avatar', Avatar)
// Vue.mixin(imMixins)
Vue.prototype.tim = tim
Vue.prototype.TIM = window.TIM
